<template>
  <div>
    <h1 class="center">SOLICITUDES</h1>
    <h3 class="center">Personalización</h3>
    <v-container style="">
      <div :style="{ width: !$vuetify.breakpoint.smAndDown ? '70%' : '100%' }">
        <v-btn class="ml-3" :color="$ajustes.colorCabecera" style="color: white;"
          @click="obtenerSolicitudes()"><v-icon>mdi-refresh</v-icon></v-btn>
      </div>
      <br>
      <v-card elevation="0" class="pa-1 pl-4 mb-1" :style="{ border: '1px solid ' + $ajustes.colorCabecera }"
        v-for="solicitud in solicitudes" :key="solicitud.id">
        <div style="display: flex;">
          <h3 style="text-align: left;">Fecha inicio: <span style="font-weight: normal;"> {{ solicitud.fecha_creacion
              }}</span></h3>
          <v-spacer></v-spacer>
          <div style="float: right;">
            <span class="ma-1 pointer" :style="{ fontWeight: solicitud.archivado == 1 ? 'bold' : null }"
              @click="archivarSolicitud(solicitud.id, 1)">ARCHIVAR</span>
            <span class="ma-1 pointer" @click="solicitudDatos = solicitud; visualizarDialogo = true">VER</span>
            <span class="ma-1 pointer" @click="eliminarSolicitud(solicitud.id)">ELIMINAR</span>
          </div>
        </div>
        <h2 style="text-align: left;"><v-icon v-if="solicitud.archivado == 1" class="mb-1 r-3" color="gold"
            small>mdi-inbox-arrow-down</v-icon>{{ solicitud.asunto }}
        </h2>
      </v-card>
    </v-container>
    <visualizar :propSolicitud="solicitudDatos" :propDialogo="visualizarDialogo" @closeDialogo="visualizarDialogo = false" />

  </div>
</template>

<script>
import * as axios from "./axios";
import visualizar from "./visualizar";

export default {
  components: {
    visualizar
  },
  data() {
    return {
      formularioDialogo: false,
      visualizarDialogo: false,
      nuevoCurso: true,
      solicitudDatos: {},
      solicitudes: [],
      axios
    };
  },
  mounted() {
    this.obtenerSolicitudes()
  },

  created() { },
  computed: {},
  methods: {
    async obtenerSolicitudes() {
      this.solicitudes = []
      var response = await axios.obtenerSolicitudes()
      this.solicitudes = response.data
    },
    async archivarSolicitud(id, estado) {
      const solicitud = {
        id: id,
        estado: estado,
      }
      await axios.archivarSolicitud(solicitud)
      this.obtenerSolicitudes()
    },
    async eliminarSolicitud(solicitudId) {
      await axios.eliminarSolicitud(solicitudId)
      this.obtenerSolicitudes()
    },
    continuar() { },
    close() { },
  },
};
</script>


<style scoped>
.centered-input>>>input {
  text-align: center;
}
</style>